/* eslint-disable react/prop-types */
import React from "react";
import ReactCountryFlag from "react-country-flag";
import CommonDashDropdown from "../common/common_dropDownDashboard";
import numberFormat from "../common/number-format";
import "./CountryBasedOverviewRow.css";

export const CountryBasedOverviewRow = ({
  paymentTypeTab,
  setPaymentTypeTab,
  countryOption,
  setCountryOption,
  countriesData = [],
  apiAdminUrl,
}) => {
  return (
    <div className="col-xl-12" style={{ marginTop: "16px" }}>
      <div className="country-card">
        <h3 className="fs-14 fw-bold textcolor mb-3">
          Country based payments overview
        </h3>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="vendor-tabs">
            <button
              className={`fs-12 vendor-tab ${
                paymentTypeTab === "Country" ? "active" : ""
              }`}
              onClick={() => setPaymentTypeTab("Country")}
            >
              Country
            </button>
            <button
              className={`fs-12 vendor-tab ${
                paymentTypeTab === "State" ? "active" : ""
              }`}
              onClick={() => setPaymentTypeTab("State")}
            >
              State
            </button>
          </div>
          {paymentTypeTab === "State" && (
            <div style={{ width: "100px" }}>
              <CommonDashDropdown
                apiUrl={`${apiAdminUrl}get_country`}
                placeholder="Select"
                value={countryOption}
                searchView={false}
                onSelect={(item) => {
                  setCountryOption(item);
                }}
              />
            </div>
          )}
        </div>

        <div className="country-list">
          {countriesData.map((item) => (
            <div className="country-row" key={item.country_name || item.state_name}>
              <div className="country-info">
                {item.country_code && (
                  <ReactCountryFlag
                    countryCode={item.country_code}
                    svg
                    style={{
                      width: "65px",
                      height: "52px",
                    }}
                  />
                )}
                <span className="fs-16 fw-600 textcolor">
                  {paymentTypeTab === "State"
                    ? item.state_name
                    : item.country_name}
                </span>
              </div>

              {/* Right: Metrics */}
              <div className="country-metrics">
                <div className="metric">
                  <span className="fs-13 fw-500 cardTextGrey">
                    Total amount
                  </span>
                  <span className="fs-16 fw-600 textcolor">
                    ₹ {numberFormat(item.total_amount)}
                  </span>
                </div>

                <div className="metric divider">
                  <span className="fs-13 fw-500 cardTextGrey">
                    Paid amount
                  </span>
                  <span className="fs-16 fw-600 textcolor">
                    ₹ {numberFormat(item.paid_amount)}
                  </span>
                </div>

                <div className="metric divider">
                  <span className="fs-13 fw-500 cardTextGrey">
                    Balance amount
                  </span>
                  <span className="fs-16 fw-600 textcolor">
                    ₹ {numberFormat(item.balance_amount)}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
